import { DataFilter } from '@siclop/kstone-vue'

export class SalaryGridFilter extends DataFilter {
  code?: string
  label?: string
  professionId?: number

  constructor(data?: Partial<SalaryGridFilter>) {
    super(data)
    if (data) {
      this.code = data.code
      this.label = data.label
      this.professionId = data.professionId
    }
  }

  override toQueryString(): string {
    let qs = super.toQueryString()
    const params: string[] = []

    if (this.code) params.push(`Code=${encodeURIComponent(this.code)}`)
    if (this.label) params.push(`Label=${encodeURIComponent(this.label)}`)
    if (this.professionId != null) params.push(`ProfessionId=${this.professionId}`)

    if (params.length > 0) {
      qs += (qs ? '&' : '?') + params.join('&')
    }
    return qs
  }
}
